import {AUTH_REGIONS, AUTH_REGIONS_SUCCESS} from 'constants/index';

export const authRegions = (payload) => ({
    type: AUTH_REGIONS, payload
})

export const authRegionsSuccess = (payload) => ({
    type: AUTH_REGIONS_SUCCESS, payload
});